import React from 'react'
import Table from 'components/Table'
import { makeSitesColumns, makeSitesRows } from '../modalTable'
import { SitesTableWrapper } from './style'
import { useNavigate } from 'react-router-dom'
import { buildAboutUrl, buildMonitoringAboutUrl, editOnly } from 'routing/constants'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { Button } from '@mui/material'
import { FormattedMessage } from 'react-intl'

const TABS = {
  ASSESSMENTS: 'assessments',
  BIODIVERSITY: 'biodiversity'
}

const AssessmentModal = ({ sites, biodiversitySites, setActiveTab, activeTab }) => {
  const history = useNavigate()
  const columns = makeSitesColumns(activeTab)
  const rows =
    activeTab === TABS.ASSESSMENTS ? makeSitesRows(sites, activeTab) : makeSitesRows(biodiversitySites, activeTab)

  const rowOnClick = (siteId, historyId, siteStatusId, monitoringId) => {
    if (activeTab === TABS.BIODIVERSITY) {
      history(buildMonitoringAboutUrl(monitoringId, siteId))
    } else {
      const editOnlySite =
        siteStatusId === SITE_STATUS_EDIT_ONLY_ID || siteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
          ? editOnly
          : null
      history(buildAboutUrl(siteId, historyId, editOnlySite))
    }
  }
  
  return (
    <>
      <SitesTableWrapper>
        <div className="tabs-wrapper">
          <Button
            className={`tab ${activeTab === TABS.ASSESSMENTS ? 'active' : ''}`}
            onClick={() => setActiveTab(TABS.ASSESSMENTS)}
          >
            <FormattedMessage id="assessments" />
          </Button>

          <Button
            className={`tab ${activeTab === TABS.BIODIVERSITY ? 'active' : ''}`}
            onClick={() => setActiveTab(TABS.BIODIVERSITY)}
          >
            <FormattedMessage id="biodiversityEvaluations" />
          </Button>
        </div>
        <Table
          columns={columns}
          rows={rows}
          noResultMessage="noReassessmentHistory"
          dataTest="sites-list"
          rowOnClick={rowOnClick}
        />
      </SitesTableWrapper>
    </>
  )
}

export default AssessmentModal